import React, { Component } from 'react';
import { Card, Row, Col, Badge, Form, Button } from 'react-bootstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import { stockService } from '../../../services/StockService';

class StockMovements extends Component {
    constructor(props) {
        super(props);
        this.state = {
            movements: [],
            loading: true,
            dateFrom: new Date(new Date().setMonth(new Date().getMonth() - 1)),
            dateTo: new Date(),
            selectedStockType: null,
            selectedCategory: null,
            filters: {}
        };
    }

    async componentDidMount() {
        await this.loadMovements();
    }

    loadMovements = async () => {
        try {
            this.setState({ loading: true });

            const filters = {
                stockId: null, // Get all movements
                dateFrom: this.state.dateFrom?.toISOString(),
                dateTo: this.state.dateTo?.toISOString(),
                stockType: this.state.selectedStockType,
                category: this.state.selectedCategory
            };

            const data = await stockService.getStockMovementReport(filters);

            // API returns {movements: MovementDto[], totalCount: number}
            this.setState({
                movements: data.movements || data.Movements || [],
                loading: false
            });
        } catch (error) {
            console.error('Error loading stock movements:', error);
            this.setState({
                movements: [],
                loading: false
            });
        }
    };

    handleFilterChange = async () => {
        await this.loadMovements();
    };

    resetFilters = async () => {
        this.setState({
            dateFrom: new Date(new Date().setMonth(new Date().getMonth() - 1)),
            dateTo: new Date(),
            selectedStockType: null,
            selectedCategory: null
        }, () => this.loadMovements());
    };

    // Template renderers for DataTable
    dateBodyTemplate = (rowData) => {
        return new Date(rowData.MovementDate || rowData.movementDate).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    typeBodyTemplate = (rowData) => {
        const typeConfig = {
            'IN': { label: 'Entrée', bg: 'success', icon: 'pi pi-arrow-down' },
            'OUT': { label: 'Sortie', bg: 'danger', icon: 'pi pi-arrow-up' },
            'ADJUSTMENT': { label: 'Ajustement', bg: 'warning', icon: 'pi pi-pencil' },
            'RESTOCK': { label: 'Réappro.', bg: 'info', icon: 'pi pi-refresh' },
            'DEFECTIVE': { label: 'Défectueux', bg: 'dark', icon: 'pi pi-times' },
            'RESERVATION': { label: 'Réservation', bg: 'secondary', icon: 'pi pi-lock' },
            'RELEASE': { label: 'Libération', bg: 'primary', icon: 'pi pi-unlock' }
        };

        const movementType = rowData.MovementType || rowData.movementType;
        const config = typeConfig[movementType] || { label: movementType, bg: 'secondary', icon: 'pi pi-question' };

        return (
            <Badge bg={config.bg}>
                <i className={`${config.icon} me-1`}></i>
                {config.label}
            </Badge>
        );
    };

    quantityBodyTemplate = (rowData) => {
        const quantity = rowData.Quantity || rowData.quantity || 0;
        const isNegative = quantity < 0;

        return (
            <span className={isNegative ? 'text-danger' : 'text-success'}>
                {isNegative ? '' : '+'}{quantity}
            </span>
        );
    };

    operatorBodyTemplate = (rowData) => {
        return rowData.OperatorName || rowData.operatorName || '-';
    };

    render() {
        const { movements, loading, dateFrom, dateTo, selectedStockType, selectedCategory } = this.state;

        const stockTypes = [
            { label: 'Tous', value: null },
            { label: 'Cartes Blanches', value: 'BLANK_CARDS' },
            { label: 'Cartouches d\'Encre', value: 'INK_CARTRIDGE' },
            { label: 'Rubans d\'Impression', value: 'RIBBON' },
            { label: 'Matériaux d\'Emballage', value: 'PACKAGING_MATERIAL' },
            { label: 'Film de Laminage', value: 'LAMINATING_FILM' },
            { label: 'Autre', value: 'OTHER' }
        ];

        const categories = [
            { label: 'Toutes', value: null },
            { label: 'Entrée', value: 'IN' },
            { label: 'Sortie', value: 'OUT' },
            { label: 'Ajustement', value: 'ADJUSTMENT' },
            { label: 'Réapprovisionnement', value: 'RESTOCK' }
        ];

        return (
            <div className="stock-movements">
                <Panel header="Mouvements de Stock" className="mb-4">
                    <small className="text-muted d-block mb-3">
                        Historique complet des mouvements de stock avec filtres avancés
                    </small>

                    {/* Filters */}
                    <Card className="mb-3">
                        <Card.Body>
                            <Row>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Date Début</Form.Label>
                                        <Calendar
                                            value={dateFrom}
                                            onChange={(e) => this.setState({ dateFrom: e.value })}
                                            dateFormat="dd/mm/yy"
                                            showIcon
                                            className="w-100"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group>
                                        <Form.Label>Date Fin</Form.Label>
                                        <Calendar
                                            value={dateTo}
                                            onChange={(e) => this.setState({ dateTo: e.value })}
                                            dateFormat="dd/mm/yy"
                                            showIcon
                                            className="w-100"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>Type de Stock</Form.Label>
                                        <Dropdown
                                            value={selectedStockType}
                                            options={stockTypes}
                                            onChange={(e) => this.setState({ selectedStockType: e.value })}
                                            placeholder="Tous"
                                            className="w-100"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <Form.Label>Catégorie</Form.Label>
                                        <Dropdown
                                            value={selectedCategory}
                                            options={categories}
                                            onChange={(e) => this.setState({ selectedCategory: e.value })}
                                            placeholder="Toutes"
                                            className="w-100"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={2} className="d-flex align-items-end">
                                    <Form.Group className="w-100">
                                        <Button
                                            variant="primary"
                                            onClick={this.handleFilterChange}
                                            className="w-100 me-1"
                                        >
                                            <i className="pi pi-search me-2"></i>
                                            Filtrer
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col md={12} className="text-end">
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={this.resetFilters}
                                    >
                                        <i className="pi pi-filter-slash me-2"></i>
                                        Réinitialiser
                                    </Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    {/* Summary Stats */}
                    <Row className="mb-3">
                        <Col md={3}>
                            <Card className="text-center border-success">
                                <Card.Body>
                                    <h6 className="text-success">Entrées</h6>
                                    <h4 className="text-success mb-0">
                                        {movements.filter(m =>
                                            (m.MovementType || m.movementType) === 'IN' ||
                                            (m.MovementType || m.movementType) === 'RESTOCK'
                                        ).reduce((sum, m) => sum + (m.Quantity || m.quantity || 0), 0)}
                                    </h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card className="text-center border-danger">
                                <Card.Body>
                                    <h6 className="text-danger">Sorties</h6>
                                    <h4 className="text-danger mb-0">
                                        {Math.abs(movements.filter(m =>
                                            (m.MovementType || m.movementType) === 'OUT'
                                        ).reduce((sum, m) => sum + (m.Quantity || m.quantity || 0), 0))}
                                    </h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card className="text-center border-warning">
                                <Card.Body>
                                    <h6 className="text-warning">Ajustements</h6>
                                    <h4 className="text-warning mb-0">
                                        {movements.filter(m =>
                                            (m.MovementType || m.movementType) === 'ADJUSTMENT'
                                        ).length}
                                    </h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card className="text-center border-info">
                                <Card.Body>
                                    <h6 className="text-info">Total Mouvements</h6>
                                    <h4 className="text-info mb-0">{movements.length}</h4>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Movements Table */}
                    <Card>
                        <Card.Body>
                            <DataTable
                                value={movements}
                                paginator
                                rows={15}
                                rowsPerPageOptions={[10, 15, 25, 50]}
                                loading={loading}
                                emptyMessage="Aucun mouvement trouvé"
                                stripedRows
                                sortMode="multiple"
                                responsiveLayout="scroll"
                                currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} mouvements"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            >
                                <Column
                                    field="Id"
                                    header="ID"
                                    sortable
                                    style={{ width: '80px' }}
                                />
                                <Column
                                    field="MovementDate"
                                    header="Date"
                                    body={this.dateBodyTemplate}
                                    sortable
                                    style={{ width: '180px' }}
                                />
                                <Column
                                    field="MovementType"
                                    header="Type"
                                    body={this.typeBodyTemplate}
                                    sortable
                                    style={{ width: '140px' }}
                                />
                                <Column
                                    field="Quantity"
                                    header="Quantité"
                                    body={this.quantityBodyTemplate}
                                    sortable
                                    style={{ width: '100px', textAlign: 'center' }}
                                />
                                <Column
                                    field="Reason"
                                    header="Motif"
                                    style={{ minWidth: '200px' }}
                                />
                                <Column
                                    field="OperatorName"
                                    header="Opérateur"
                                    body={this.operatorBodyTemplate}
                                    style={{ width: '150px' }}
                                />
                            </DataTable>
                        </Card.Body>
                    </Card>
                </Panel>
            </div>
        );
    }
}

export default StockMovements;
